module.exports = __webpack_public_path__ + "img/info.6a1a6b99.svg";